import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("crejpp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Cuenta deshabilitada: cerrar sesión en la siguiente petición al servidor
api.interceptors.response.use(
  (r) => r,
  (error) => {
    const detail = error.response?.data?.detail;
    if (typeof detail === "string" && detail.toLowerCase().includes("deshabilitada")) {
      localStorage.removeItem("crejpp_token");
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Ocurrió un error. Intente nuevamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
